export class QuoteRequest {
  correlationId: string;
  trips: Trip[];
}

export class Trip {
  destination: string;
  startDate: string;
  endDate: string;
  tripCost: number;
  tripPoints: number;
  travelers: Traveler[];
}

export class Traveler {
  tripCost: number;
  state: string;
}

export interface QuoteResponse {
  coverages: Coverage[];
  description: string;
  price: number;
  product: string;
  provider: string;
  offerId: string;
  quoteId: string;
}

export interface Coverage {
  description: string;
  effectiveDate: string;
  service: boolean;
  type: string;
}
